/* eslint-disable no-empty */
import { apply, call, put, all, select } from 'redux-saga/effects';
import ironLegacyClient from '@app/data/ironLegacyClient';
import { DOM, isBrowser } from '@app/utils';

import { getIsEmployee } from '@app/redux/customer/selectors';
import { getCurrencies } from '@app/redux/currency/selectors';
import { updateUserCurrency, setAllCurrencies } from './actions';
import type { EffectCreatorParams } from '../types';

export const setCurrencyCookie = (
  action: EffectCreatorParams<{ currency: string }>,
) => {
  const {
    payload: { currency },
  } = action;

  const selectedCurrency = currency;
  DOM.forceSetCookie('stockx_selected_currency', selectedCurrency);
};

export const setLocalCookie = (
  action: EffectCreatorParams<{ locale?: string }>,
) => {
  const {
    payload: { locale },
  } = action;

  if (locale) {
    DOM.forceSetCookie('stockx_selected_locale', locale);
  }
};

export const onUpdateCustomerCurrency = function* onUpdateCustomerCurrency(
  action: EffectCreatorParams<{ currency: string; customerId?: string }>,
) {
  const { currency, customerId } = action.payload;

  if (customerId) {
    try {
      const customer = {
        Customer: {
          defaultCurrency: currency,
        },
      };

      const res = yield apply(
        ironLegacyClient,
        ironLegacyClient.updateCustomer,
        [customerId, customer],
      );

      const newCustomer = res.body.Customer;
      newCustomer.updated = true;
    } catch (e) {}
  }
};

// eslint-disable-next-line require-yield
export const onSetUserCurrencyReload = function* onSetUserCurrencyReload(
  action: EffectCreatorParams<{ reload?: boolean }>,
) {
  const {
    payload: { reload },
  } = action;

  if (reload) {
    if (isBrowser) {
      window.location.reload();
    }
  }
};

export const onGetAllCurrencies = function* onGetAllCurrencies() {
  const currencies = yield select(getCurrencies);

  // Only load currencies if we do not already have currencies
  if (Object.keys(currencies ?? {}).length !== 0) {
    return;
  }

  try {
    const isTeamMember = yield select(getIsEmployee);
    const res = yield apply(ironLegacyClient, ironLegacyClient.getCurrencies, [
      isTeamMember,
    ]);

    yield put(setAllCurrencies(res.body.currencies));
  } catch (err) {
    yield put(setAllCurrencies({}));
  }
};

export const onSetUserCurrency = function* onSetUserCurrency(
  action: EffectCreatorParams<{
    currency: string;
    locale: string;
    reload?: boolean;
    customerId?: string;
  }>,
) {
  const { currency, locale } = action.payload;

  try {
    yield all([
      call(setCurrencyCookie, action),
      call(setLocalCookie, action),
      put(updateUserCurrency({ currency, locale })),
      call(onUpdateCustomerCurrency, action),
    ]);
    yield call(onSetUserCurrencyReload, action);
  } catch (e) {
    yield put(updateUserCurrency({ currency: 'USD', locale: 'US' }));
  }
};
